import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import cn from 'classnames';
import styles from './PrizeTooltip.module.scss';
import Paragraph from '../../Typography/Paragraph/Paragraph';
var TooltipEnum;
(function (TooltipEnum) {
    TooltipEnum["OPEN"] = "open";
    TooltipEnum["CLOSE"] = "close";
})(TooltipEnum || (TooltipEnum = {}));
const PrizeTooltip = ({ className, onClick, children, content }) => {
    const tooltipState = {
        [TooltipEnum.OPEN]: true,
        [TooltipEnum.CLOSE]: false
    };
    const [active, setActive] = useState(false);
    const handleOpenTooltip = (tooltip) => {
        setActive(tooltipState[tooltip]);
    };
    return (_jsxs("div", Object.assign({ "data-testid": "prizeTooltip", onClick: onClick, onMouseLeave: () => handleOpenTooltip('close'), onMouseEnter: () => handleOpenTooltip('open'), className: cn(styles.element, className, active && styles['isActive'], 'd-flex align-items-center') }, { children: [children, active && content && (_jsx("div", Object.assign({ className: cn(styles.tooltip) }, { children: _jsx("div", Object.assign({ className: cn(styles.context) }, { children: _jsxs("div", Object.assign({ className: cn(styles.places, 'd-flex') }, { children: [_jsxs("div", { children: [_jsx(Paragraph, { title: '1st place', color: 'grey', size: 1, fontFamily: 'urbanist' }), _jsx(Paragraph, { color: 'white', size: 2, title: content[0] })] }), _jsxs("div", { children: [_jsx(Paragraph, { title: '2nd place', color: 'grey', size: 1, fontFamily: 'urbanist' }), _jsx(Paragraph, { color: 'white', size: 2, title: content[1] })] }), _jsxs("div", { children: [_jsx(Paragraph, { title: '3rd place', color: 'grey', size: 1, fontFamily: 'urbanist' }), _jsx(Paragraph, { color: 'white', size: 2, title: content[2] })] })] })) })) })))] })));
};
export default PrizeTooltip;
